module.exports = __webpack_public_path__ + "img/1.f826a784.svg";